import React, { createContext, useContext, useState } from "react";

const AutomatonContext = createContext();

export default function AutomatonProvider({ children }) {
  const [arrayElements, setArrayElements] = useState([]);

  const [dot, setDot] = useState("");
  const [createdDate, setCreatedDate] = useState(null);
  const [dotName, setDotName] = useState(null);
  const [automatonType, setAutomatonType] = useState(null);
  const [drawableDot, setDrawableDot] = useState("");
  const [afndDot, setAfndDot] = useState("");
  const [currentAlgorithm, setCurrentAlgorithm] = useState("");
  const [isActiveDialogImportDot, setActiveDialogImportDot] = useState(false);
  const [isActiveDialogHistorical, setActiveDialogHistorical] = useState(false);
  const [isActiveDialogRegex, setActiveDialogRegex] = useState(false);
  const [isActiveDialogSimulate, setActiveDialogSimulate] = useState(false);

  const [actualMachine, setActualMachine] = useState([]);
  const [childs1, setChilds] = useState([]);
  const [responseAFNDLambda, setResponseAFNDLambda] = useState("");
  const [responseTableAFNDLambda, setResponseTableAFNDLambda] = useState({});
  const [responseTableAFND, setResponseTableAFND] = useState({});
  const [responseTableAFD, setResponseTableAFD] = useState({});
  const [responseTableMinimization, setResponseTableMinimization] = useState(
    {}
  );
  const [machineStates, setMachineStates] = useState([
    // {
    //   id: "q1",
    //   key: "q1",
    //   x: 2500,
    //   y: 100,
    //   color: "blue",
    //   text: "q1",
    //   isInitial: true,
    //   isFinal: true,
    //   visible: true,
    // },
  ]);
  const [machineTransitions, setMachineTransitions] = useState([]);
  const [machineStatesResponse, setMachineStatesResponse] = useState([]);
  const [machineTransitionsResponse, setMachineTransitionsResponse] = useState(
    []
  );
  const [wordSimulate, setWordSimulate] = useState("");
  const [responseSimulate, setResponseSimulate] = useState({});

  const [dataTreeDerivation, setDataTreeDerivation] = useState({});

  const [isSimulating, setIsSimulating] = useState(false);
  const [simulationPath, setSimulationPath] = useState([]);
  const [simulationIndex, setSimulationIndex] = useState(0);

  const [isMultiPathSimulating, setIsMultiPathSimulating] = useState(false);
  const [currentComputationLevel, setCurrentComputationLevel] = useState(0);

  return (
    <AutomatonContext.Provider
      value={{
        dot,
        setDot,
        dotName,
        setDotName,
        createdDate,
        setCreatedDate,
        drawableDot,
        setDrawableDot,
        currentAlgorithm,
        setCurrentAlgorithm,
        arrayElements,
        setArrayElements,
        actualMachine,
        setActualMachine,
        childs1,
        setChilds,
        isActiveDialogImportDot,
        setActiveDialogImportDot,
        isActiveDialogHistorical,
        setActiveDialogHistorical,
        isActiveDialogRegex,
        setActiveDialogRegex,
        isActiveDialogSimulate,
        setActiveDialogSimulate,
        machineStates,
        setMachineStates,
        machineTransitions,
        setMachineTransitions,
        machineStatesResponse,
        setMachineStatesResponse,
        machineTransitionsResponse,
        setMachineTransitionsResponse,
        responseAFNDLambda,
        setResponseAFNDLambda,
        responseTableAFNDLambda,
        setResponseTableAFNDLambda,
        responseTableAFND,
        setResponseTableAFND,
        responseTableAFD,
        setResponseTableAFD,
        responseTableMinimization,
        setResponseTableMinimization,
        afndDot,
        setAfndDot,
        wordSimulate,
        setWordSimulate,
        responseSimulate,
        setResponseSimulate,
        dataTreeDerivation,
        setDataTreeDerivation,
        automatonType,
        setAutomatonType,
        isSimulating,
        setIsSimulating,
        simulationPath,
        setSimulationPath,
        simulationIndex,
        setSimulationIndex,
        isMultiPathSimulating,
        setIsMultiPathSimulating,
        currentComputationLevel,
        setCurrentComputationLevel,
      }}
    >
      {children}
    </AutomatonContext.Provider>
  );
}

export function useDot() {
  const context = useContext(AutomatonContext);
  const {
    dot,
    setDot,
    dotName,
    setDotName,
    createdDate,
    setCreatedDate,
    drawableDot,
    setDrawableDot,
    currentAlgorithm,
    setCurrentAlgorithm,
    arrayElements,
    setArrayElements,
    actualMachine,
    setActualMachine,
    childs1,
    setChilds,
    isActiveDialogImportDot,
    setActiveDialogImportDot,
    isActiveDialogHistorical,
    setActiveDialogHistorical,
    isActiveDialogRegex,
    setActiveDialogRegex,
    isActiveDialogSimulate,
    setActiveDialogSimulate,
    machineStates,
    setMachineStates,
    machineTransitions,
    setMachineTransitions,
    machineStatesResponse,
    setMachineStatesResponse,
    machineTransitionsResponse,
    setMachineTransitionsResponse,
    responseAFNDLambda,
    setResponseAFNDLambda,
    responseTableAFNDLambda,
    setResponseTableAFNDLambda,
    responseTableAFND,
    setResponseTableAFND,
    responseTableAFD,
    setResponseTableAFD,
    responseTableMinimization,
    setResponseTableMinimization,
    afndDot,
    setAfndDot,
    wordSimulate,
    setWordSimulate,
    responseSimulate,
    setResponseSimulate,
    dataTreeDerivation,
    setDataTreeDerivation,
    automatonType,
    setAutomatonType,
    isSimulating,
    setIsSimulating,
    simulationPath,
    setSimulationPath,
    simulationIndex,
    setSimulationIndex,
    isMultiPathSimulating,
    setIsMultiPathSimulating,
    currentComputationLevel,
    setCurrentComputationLevel,
  } = context;
  return {
    dot,
    setDot,
    dotName,
    setDotName,
    createdDate,
    setCreatedDate,
    drawableDot,
    setDrawableDot,
    currentAlgorithm,
    setCurrentAlgorithm,
    arrayElements,
    setArrayElements,
    actualMachine,
    setActualMachine,
    childs1,
    setChilds,
    isActiveDialogImportDot,
    setActiveDialogImportDot,
    isActiveDialogHistorical,
    setActiveDialogHistorical,
    isActiveDialogRegex,
    setActiveDialogRegex,
    isActiveDialogSimulate,
    setActiveDialogSimulate,
    machineStates,
    setMachineStates,
    machineTransitions,
    setMachineTransitions,
    machineStatesResponse,
    setMachineStatesResponse,
    machineTransitionsResponse,
    setMachineTransitionsResponse,
    responseAFNDLambda,
    setResponseAFNDLambda,
    responseTableAFNDLambda,
    setResponseTableAFNDLambda,
    responseTableAFND,
    setResponseTableAFND,
    responseTableAFD,
    setResponseTableAFD,
    responseTableMinimization,
    setResponseTableMinimization,
    afndDot,
    setAfndDot,
    wordSimulate,
    setWordSimulate,
    responseSimulate,
    setResponseSimulate,
    dataTreeDerivation,
    setDataTreeDerivation,
    automatonType,
    setAutomatonType,
    isSimulating,
    setIsSimulating,
    simulationPath,
    setSimulationPath,
    simulationIndex,
    setSimulationIndex,
    isMultiPathSimulating,
    setIsMultiPathSimulating,
    currentComputationLevel,
    setCurrentComputationLevel,
  };
}
